import { Button } from '@nesso/ui/primitives/button';
import { Separator } from '@nesso/ui/primitives/separator';

import { BillingHistory } from '@/entities/billing-history';
import {
    formatPaymentMethod,
    formatPaymentNumber,
    type Payment,
    type Refund,
} from '@/entities/payment';

type Props = {
    refund: Refund;
    isCompact: boolean;
    onOpenOriginalPayment: (payment: Payment) => void;
};

export function ClientBillingSheetActivityRefundDetails({
    refund,
    isCompact,
    onOpenOriginalPayment,
}: Props) {
    return (
        <div className="flex flex-col gap-4 text-sm">
            <section className="flex flex-col gap-1">
                <h4 className="font-bold">Original payment</h4>
                <Button
                    type="button"
                    variant="inline-link"
                    className="self-start"
                    onClick={() => onOpenOriginalPayment(refund.payment)}
                >
                    {formatPaymentNumber(refund.payment.number)}
                </Button>
            </section>
            {isCompact && (
                <section className="flex flex-col gap-1">
                    <h4 className="font-bold">Method</h4>
                    <p>{formatPaymentMethod(refund.method, refund.checkNumber)}</p>
                </section>
            )}
            <Separator />
            <section className="flex flex-col gap-2">
                <h4 className="font-bold">History</h4>
                <BillingHistory entries={refund.history} />
            </section>
        </div>
    );
}
